/*
 * Copyright 2026 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
'use client';

import 'client-only';
import { createContext } from 'react';
import type { ContextValue } from 'react-aria-components/slots';
import type { RadioGroupProps, RadioProps } from './types';

/**
 * Context for RadioGroup component
 *
 * Provides context for RadioGroup component to share state with Radio components
 */
export const RadioGroupContext =
  createContext<ContextValue<RadioGroupProps, HTMLDivElement>>(null);

/**
 * Context for Radio component
 *
 * Provides context for Radio component to share configuration from RadioGroup
 */
export const RadioContext =
  createContext<ContextValue<RadioProps, HTMLLabelElement>>(null);
